const teamMembers = [
  {
    name: 'Evren Yucekus-Kissane',
    role: 'Founder & Executive Director',
    image: '/evren.JPG',
    linkedin: 'https://www.linkedin.com/in/evrenyk/',
    bio: `Evren has conducted and presented quantum Machine Learning (ML) and Natural Language Processing (NLP) research. He holds 3+ years of experience in software development with a focus on ML and NLP and has 2+ years of experience in R&D at global pharmaceutical companies.`,
  },
];

export default teamMembers;
